import { ConfirmDialog } from '@/components/ui/confirm-dialog';
import { useConfirmDialog, useConfirmDialogActions } from '@/stores/confirmDialogStore';

export const GlobalConfirmDialog: React.FC = () => {
  const { isOpen, title, description, type, confirmLabel, cancelLabel, loading, instantClose } =
    useConfirmDialog();
  const { _confirm, _cancel } = useConfirmDialogActions();

  return (
    <ConfirmDialog
      open={isOpen}
      onOpenChange={(open) => !open && _cancel()}
      title={title}
      description={description}
      type={type}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      loading={loading}
      instantClose={instantClose}
      onConfirm={_confirm}
      onCancel={_cancel}
    />
  );
};
